var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectelWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1146.6 645",
    style: {
      enableBackground: "new 0 0 1146.6 645"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#122438;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E83C51;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M866.7,390.5l1.8,29.9c-4.9,2.4-17.4,3.7-23.8,3.7c-32.3,0-55.1-20.2-56.1-55.8h34c1.6,15.1,13.1,24,26.9,24 C853.2,392.3,863.6,391.4,866.7,390.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.7,
    y: 232.7,
    className: "st1",
    width: 33.9,
    height: 189.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M703.7,302.3c16.2,0,29.6,7.9,35.7,19.8l28.7-16.2c-11-22-35.4-36.3-64.4-36.3c-44.3,0-77.8,33.6-77.8,77.8 c0,44.3,33.9,77.5,78.1,77.5c27.4,0,51-12.5,64-32.4l-28.4-17.4c-7.5,10.8-20.4,17.1-35.6,17.1c-25.6,0-44.6-19.5-44.6-44.9 C659.5,321.8,678.1,302.3,703.7,302.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.4,340.7c0-40-31.4-71.1-71.7-71.1c-43,0-76.9,33.6-76.9,76.9c0,44.6,34.5,78.5,77.5,78.5 c30.8,0,55.9-12.2,66.9-32.4L354,375.2c-7,11.6-22.3,18.9-39.1,18.9c-24.1,0-40.6-14.6-44.3-38.8h113.6 C385.1,350.8,385.4,344.7,385.4,340.7 M271.8,329.4c5.2-19.5,19.5-31.7,40-31.7s36,13.1,37.9,31.7H271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M606.6,340.7c0-40-31.4-71.1-71.7-71.1c-43,0-76.9,33.6-76.9,76.9c0,44.6,34.5,78.5,77.5,78.5 c30.8,0,55.9-12.2,66.9-32.4l-27.2-17.4c-7,11.6-22.3,18.9-39.1,18.9c-24.1,0-40.6-14.6-44.3-38.8h113.6 C606.3,350.8,606.6,344.7,606.6,340.7 M493,329.4c5.2-19.5,19.5-31.7,40-31.7s36,13.1,37.9,31.7H493z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1030.2,340.7c0-40-31.4-71.1-71.7-71.1c-43,0-76.9,33.6-76.9,76.9c0,44.6,34.5,78.5,77.5,78.5 c30.8,0,55.9-12.2,66.9-32.4l-27.2-17.4c-7,11.6-22.3,18.9-39.1,18.9c-24.1,0-40.6-14.6-44.3-38.8H1029 C1029.9,350.8,1030.2,344.7,1030.2,340.7 M916.7,329.4c5.2-19.5,19.5-31.7,40-31.7s36,13.1,37.9,31.7H916.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.5,
    y: 232.7,
    className: "st1",
    width: 33.9,
    height: 189.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.7,386.9c-8.1,5.1-17.8,7.7-29.1,7.7c-12.2,0-22.8-3.2-31.9-9.7c-9-6.5-15-15.5-17.9-27.2l-33.6,5.2 c2,12.6,6.7,23.6,14.1,33s16.9,16.6,28.4,21.6c11.6,5,24.6,7.5,39,7.5c13.9,0,26.6-2.3,38.3-7s21-11.6,28-20.9 c6.2-8.2,9.6-17.7,10.4-28.7h-33.6C187.1,376.1,183.1,382.3,175.7,386.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "822.4,355.4 788.5,355.4 788.5,305 788.5,305 788.5,272.6 788.5,232.6 822.4,232.6 822.4,272.6  867,272.6 867,305 822.4,305 822.4,305  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.2,334.6c-5.6-7.3-12-12.6-19.3-16s-15.6-6.3-24.9-8.9l-35.3-10.1c-8.8-2.2-15.8-5-21.1-8.5 c-5.3-3.5-7.9-8.6-7.9-15.3c0-5.1,1.7-9.6,5.2-13.5s8.1-6.9,13.8-9c5.7-2.1,11.9-3.1,18.5-2.9c10.6,0.2,19.9,3.2,27.9,9.2 c8,5.9,13.1,13.9,15.3,23.9l34.7-5.7c-2.9-12.2-7.9-22.6-14.9-31.2c-7-8.6-15.9-15.1-26.5-19.6c-10.7-4.5-22.7-6.8-36-7 c-13.7-0.2-25.9,2-36.8,6.4c-10.9,4.5-19.4,11-25.7,19.7c-6.3,8.7-9.4,19.1-9.4,31.3c0,15.1,4.2,26.4,12.6,33.8 s18.8,12.8,31.2,16.3l50.9,15c7.7,2.4,13.3,5.4,17,9.2c1.1,1.1,2,2.4,2.7,3.7h35.9C220.1,347.1,217.4,340.2,213.2,334.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectelWhitecolor);
export default __webpack_public_path__ + "static/media/Selectel_white+color.83c04a133e45e6d502f56c5418f884b8.svg";
export { ForwardRef as ReactComponent };